import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const invicti = defineConnector({
  identifier: "invicti",
  name: "Invicti",
  tagLine: "Web application security scanning",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://www\\.netsparkercloud\\.com/api/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.userId,
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log into [Invicti](https://www.netsparkercloud.com) and go to your account page. Copy your **User ID** and **API Token**.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "User ID",
          required: true,
          target: { kind: "configuration", field: "userId" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.netsparkercloud.com/api/1.0/scans/list",
  },
});
